var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrowChart = function SvgGrowChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    strokeLinecap: "round",
    clipPath: "url(#grow-chart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.79 1.22V50.39a6.986 6.986 0 0 0 6.985 6.986h49.169"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m11.07 50.516 21.563-21.594 4.834 4.833 13.792-13.792"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M37.96 19.15h14.138v14.137"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grow-chart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .166h58v58H0z"
  })))));
};
export default SvgGrowChart;